unit U_ParseHelper;

interface

uses
  System.SysUtils, JS, Web, System.StrUtils;

type
  THttpParse = class
  public
    /// Build a friendly message from HTTP status + response body
    class function BuildUserMessage(Status: Integer; const ResponseText: string)
      : string; static;

    /// Decide success vs error and give you the message to show the user.
    /// If Status is 200/201/202/204 => IsSuccess=True and Msg=SuccessMsg.
    /// Otherwise IsSuccess=False and Msg=BuildUserMessage(Status, ResponseText).
    class procedure StatusFromResponse(const AReq: TJSXMLHttpRequest;
      const SuccessMsg: string; out IsSuccess: Boolean;
      out Msg: string); static;
  private
    class function ExtractServerMessage(const ResponseText: string)
      : string; static;
    class function ParseJsonMessage(const S: string): string; static;
    class function StripHtml(const S: string): string; static;
  end;

implementation

{ THttpParse }

class function THttpParse.ParseJsonMessage(const S: string): string;
begin
  Result := '';
  asm
    try {
    var data = JSON.parse(S);

    // Some backends double-encode the payload as a JSON string
    if (typeof data === 'string') {
    try { data = JSON.parse(data); } catch(e) { }
    }

    var msg =
    (data && (data.message || data.error || data.title)) ||
    (data && data.errors && (data.errors[0]?.message || data.errors[0])) ||
    '';

    if (!msg && data && data.classname && data.message) {
    msg = data.message;
     }

    Result = msg ? String(msg) : '';
    } catch(e) {
    Result = '';
     }
  end;
end;

class function THttpParse.StripHtml(const S: string): string;
begin
  asm
    var div = document.createElement('div');
    div.innerHTML = S;
    Result = String(div.textContent || div.innerText || '');
  end;
  Result := Result.Replace('\r', sLineBreak).Replace('\n', sLineBreak).Trim;
end;

class function THttpParse.ExtractServerMessage(const ResponseText
  : string): string;
begin
  Result := ParseJsonMessage(ResponseText);
  if Result = '' then
    Result := StripHtml(ResponseText);
end;

class function THttpParse.BuildUserMessage(Status: Integer;
  const ResponseText: string): string;
var
  Msg: string;
begin
  Msg := ExtractServerMessage(ResponseText);

  case Status of
    0:
      Result := 'Serveur injoignable ou connexion perdue.';
    400:
      Result := IfThen(Msg <> '', Msg, 'Requête invalide (400).');
    401:
      Result := IfThen(Msg <> '', Msg, 'Non autorisé (401).');
    403:
      Result := IfThen(Msg <> '', Msg, 'Accès interdit (403).');
    404:
      Result := IfThen(Msg <> '', Msg, 'Ressource introuvable (404).');
    409:
      Result := IfThen(Msg <> '', Msg, 'Conflit de données (409).');
    422:
      Result := IfThen(Msg <> '', Msg, 'Erreur de validation (422).');
    500 .. 599:
      begin
        if Msg <> emptyStr then
        begin
          if ContainsText(Msg, 'TIM_PRESENCE_DATE_INVERSE') then
            Msg := 'La date de fin se trouve avant la date de début'
          else
            Msg := 'Erreur serveur : ' + Msg;
        end;
        Result := IfThen(Msg <> '', Msg, 'Erreur serveur (' +
          Status.ToString + ').');
      end
  else
    Result := IfThen(Msg <> '', Msg, Format('Erreur HTTP %d.', [Status]));
  end;
end;

class procedure THttpParse.StatusFromResponse(const AReq: TJSXMLHttpRequest;
  const SuccessMsg: string; out IsSuccess: Boolean; out Msg: string);
begin
  case AReq.Status of
    200, 201, 202, 204:
      begin
        IsSuccess := True;
        Msg := SuccessMsg;
      end;
  else
    IsSuccess := False;
    Msg := BuildUserMessage(AReq.Status, string(AReq.ResponseText));
  end;
end;

end.
